let scriptIsLoaded = false;
let scriptIsLoading = false;
const scriptLoadingListeners = [];

export function scriptImporterIsLoaded() {
  return scriptIsLoaded;
}

export function importScript(globalName, scriptURL, callback) {
  scriptIsLoaded = !!window[globalName];

  if (scriptImporterIsLoaded()) {
    return Promise.resolve();
  }

  if (scriptIsLoading) {
    return new Promise(resolve => {
      scriptLoadingListeners.push(resolve);
    });
  }

  scriptIsLoading = true;
  window[globalName] = callback;

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = scriptURL;
    script.async = true;
    script.addEventListener('load', () => {
      scriptIsLoaded = true;
      scriptIsLoading = false;
      scriptLoadingListeners.forEach(resolver => resolver());
    });
    scriptLoadingListeners.push(resolve);
    script.addEventListener('error', reject);

    document.head.appendChild(script);
  });
}
